import { ServiceHelper } from "./ServiceHelper";
import { URL_CONSTANTS } from "../_constants";

export const NfcService = {
    getCardInfo,
    updateCard,
    uploadAvatar,
};

async function getCardInfo(code) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.NFC_INFO,
        {
            card_code: code,
        },
    );
}

async function updateCard(code, userEmail, userName, userLastName, clockinLegalID, clockinAdditionalInfo) {
    let body = {
        card_code: code,
    }

    if (userEmail) {
        body.user_email = userEmail;
    }
    if (userName) {
        body.user_name = userName;
    }
    if (userLastName) {
        body.user_last_name = userLastName;
    }
    if (clockinLegalID) {
        body.clockin_legal_id = clockinLegalID;
    }
    if (clockinAdditionalInfo) {
        body.clockin_additional_info = clockinAdditionalInfo;
    }

    return await ServiceHelper.postRequest(
        URL_CONSTANTS.NFC_UPDATE,
        body,
    );
}

async function uploadAvatar(cardCode, avatar) {
    console.log(URL_CONSTANTS.NFC_AVATAR + '/' + cardCode, cardCode);
    return await ServiceHelper.postImageRequest(
        URL_CONSTANTS.NFC_AVATAR + '/' + cardCode,
        avatar
    )
}